// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__1t6Gs","img":"Arrow_img__NyY7N","left":"Arrow_left__2CBOx","right":"Arrow_right__3rPey","show":"Arrow_show__PEaKg","hide":"Arrow_hide__1gyvW"};